import { useSyncExternalStore } from "react"

let isOpen = false
let isStandardOpen = false
const listeners = new Set<() => void>()

/**
 * @param open Whether a bottom-docked PromotionBanner is currently open.
 * @param isStandard Whether the open banner is the standard (full-width
 * "Banner") variant, as opposed to the Promo Card. Ignored when `open` is false.
 */
export function setPromotionBannerOpen(open: boolean, isStandard = false) {
  const nextStandardOpen = open && isStandard
  if (open === isOpen && nextStandardOpen === isStandardOpen) return
  isOpen = open
  isStandardOpen = nextStandardOpen
  listeners.forEach(listener => listener())
}

function subscribe(listener: () => void) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

const getSnapshot = () => isOpen
const getStandardSnapshot = () => isStandardOpen
const getServerSnapshot = () => false

/** True while a bottom-docked PromotionBanner is open: the full-width banner, or the Promo Card on mobile. */
export function usePromotionBannerOpen() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}

/** True only while the standard (full-width "Banner" variant) PromotionBanner is open. */
export function useStandardPromotionBannerOpen() {
  return useSyncExternalStore(subscribe, getStandardSnapshot, getServerSnapshot)
}
